module.exports = __webpack_public_path__ + "img/futmesa.d60c37bc.png";